var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.351648,
    y: 0.351648,
    width: 15.2967,
    height: 15.2967,
    rx: 7.64835,
    fill: "#FFEBA7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.351648,
    y: 0.351648,
    width: 15.2967,
    height: 15.2967,
    rx: 7.64835,
    stroke: "white",
    strokeWidth: 0.703297
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72236 7.92235L7.94009 5.69458L6.15782 7.92235L3.52295 6.37249L4.7355 11.1483C4.7355 11.6191 6.01407 12.0007 7.94009 12.0007C9.86619 12.0007 11.1447 11.6191 11.1447 11.1483L12.3572 6.37249L9.72236 7.92235Z",
    fill: "#FDC00F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 11.5814C6.15024 11.3662 4.96731 8.74749 4.24037 6.79255L3.52246 6.37024L4.73502 11.146C4.73502 11.6169 6.01358 11.9985 7.9396 11.9985C9.03913 11.9985 9.92641 11.8736 10.4865 11.6795C9.47428 11.7233 8.18081 11.7355 7.33334 11.5814Z",
    fill: "#F99615"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72236 7.92234L7.94009 5.69458L6.15782 7.92234L3.52295 6.37249L6.07274 8.4659L8.02669 6.3874L9.58567 8.4659L11.6643 7.16791L10.6444 11.6222C10.9667 11.4867 11.1447 11.3238 11.1447 11.1483L12.3572 6.37249L9.72236 7.92234Z",
    fill: "#FFCC4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7795 7.25151C4.21001 7.25151 4.559 6.90254 4.559 6.47207C4.559 6.04159 4.21001 5.69263 3.7795 5.69263C3.34899 5.69263 3 6.04159 3 6.47207C3 6.90254 3.34899 7.25151 3.7795 7.25151Z",
    fill: "#FDC00F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60648 6.14256C3.93962 6.14256 4.22204 6.35281 4.33347 6.64711C4.36663 6.57216 4.38592 6.48962 4.38592 6.40236C4.38592 6.06753 4.11443 5.79614 3.77963 5.79614C3.49246 5.79614 3.25288 5.99659 3.19043 6.26491C3.31105 6.18839 3.45298 6.14256 3.60648 6.14256Z",
    fill: "#FFCC4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77947 6.90517C3.40865 6.90517 3.09977 6.64579 3.02084 6.29895C3.00814 6.35488 3 6.41246 3 6.47215C3 6.90266 3.34896 7.25156 3.77947 7.25156C4.20996 7.25156 4.55898 6.90263 4.55898 6.47215C4.55898 6.41246 4.55083 6.35485 4.53813 6.29895C4.45912 6.64579 4.15027 6.90517 3.77947 6.90517Z",
    fill: "#F99615"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93231 6.55932C8.3628 6.55932 8.71178 6.21036 8.71178 5.7799C8.71178 5.34944 8.3628 5.00049 7.93231 5.00049C7.50181 5.00049 7.15283 5.34944 7.15283 5.7799C7.15283 6.21036 7.50181 6.55932 7.93231 6.55932Z",
    fill: "#FDC00F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75882 5.45152C8.09204 5.45152 8.37436 5.66174 8.48581 5.9561C8.51902 5.88115 8.53832 5.79858 8.53832 5.71132C8.53832 5.37649 8.26675 5.1051 7.932 5.1051C7.6448 5.1051 7.40519 5.30552 7.34277 5.57387C7.46345 5.49732 7.60532 5.45152 7.75882 5.45152Z",
    fill: "#FFCC4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93228 6.21215C7.56148 6.21215 7.25263 5.95279 7.17359 5.60596C7.16092 5.66186 7.15283 5.71944 7.15283 5.77915C7.15283 6.20961 7.50177 6.55857 7.93228 6.55857C8.36279 6.55857 8.71178 6.20958 8.71178 5.77915C8.71178 5.71942 8.70361 5.66183 8.69096 5.60596C8.61198 5.95279 8.30308 6.21215 7.93228 6.21215Z",
    fill: "#F99615"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9226 7.25249C12.3531 7.25249 12.7021 6.90352 12.7021 6.47305C12.7021 6.04257 12.3531 5.6936 11.9226 5.6936C11.4921 5.6936 11.1431 6.04257 11.1431 6.47305C11.1431 6.90352 11.4921 7.25249 11.9226 7.25249Z",
    fill: "#FDC00F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7489 6.14464C12.0822 6.14464 12.3645 6.35488 12.476 6.64919C12.5092 6.57424 12.5285 6.4917 12.5285 6.40443C12.5285 6.06961 12.257 5.79822 11.9222 5.79822C11.635 5.79822 11.3954 5.99866 11.333 6.26699C11.4537 6.19046 11.5955 6.14464 11.7489 6.14464Z",
    fill: "#FFCC4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9226 6.90529C11.5518 6.90529 11.2429 6.64591 11.1639 6.29907C11.1512 6.355 11.1431 6.41259 11.1431 6.47227C11.1431 6.90278 11.4921 7.25168 11.9226 7.25168C12.3531 7.25168 12.702 6.90275 12.702 6.47227C12.702 6.41259 12.694 6.35497 12.6812 6.29907C12.6023 6.64591 12.2934 6.90529 11.9226 6.90529Z",
    fill: "#F99615"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1186 9.8595C10.5956 10.2055 9.27513 10.5 7.71693 10.5814C6.407 10.6499 5.24988 10.5506 4.58545 10.3451C4.99885 10.6776 6.31717 10.9212 7.88089 10.9212C9.7756 10.9212 11.3115 10.564 11.3115 10.1232C11.3115 10.0308 11.2432 9.9422 11.1186 9.8595Z",
    fill: "#FFCC4D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55957 10.4584L4.66282 10.8646C5.29291 11.1891 6.52374 11.4095 7.9391 11.4095C9.35452 11.4095 10.5854 11.1891 11.2154 10.8646L11.3186 10.4584C10.7298 10.8151 9.43939 11.063 7.9391 11.063C6.43885 11.063 5.14847 10.8151 4.55957 10.4584Z",
    fill: "#FFCC4D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50342 10.2493L4.60813 10.6618C5.21959 11.0023 6.47833 11.2365 7.93602 11.2365C9.3937 11.2365 10.6524 11.0023 11.2639 10.6618L11.3687 10.2493C10.8089 10.6252 9.48607 10.8901 7.93602 10.8901C6.38593 10.8901 5.06311 10.6252 4.50342 10.2493Z",
    fill: "#F99615"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCrown);
export default __webpack_public_path__ + "static/media/gold-crown.1a33b0ade68a7d061046e959956fe5a9.svg";
export { ForwardRef as ReactComponent };